import { addToChainAfter, addToStartOfChain, ApiHandler, ApiHandlerDiscreteParameter, HandlerWithResult, HasOnError, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    createHandlerChainRunnerOptionalParameter,
    Handler,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { AddCartLinesApiParameter, AddWishListToCartApiParameter, Cart, CartResult, ClearCartApiParameter, RemoveCartLineApiParameter, UpdateCartApiParameter } from "@insite/client-framework/Services/CartService";
import { chain, LoadCart, UpdateCart } from "@insite/client-framework/Store/Pages/Cart/Handlers/SubmitRequisition";
import { CartLineCollectionModel, CartModel } from "@insite/client-framework/Types/ApiModels";
import { addCartModifiedToLocalStorage } from "@NA/Utils/Utility";

type HandlerType = HandlerWithResult<HasOnSuccess<Cart>, Cart, { cartToUpdate: CartModel }>;

export const PushAddToCartCompleteInLocalStorage: HandlerType = props => {
    addCartModifiedToLocalStorage();
};

addToStartOfChain(chain, PushAddToCartCompleteInLocalStorage); // UpdateCart,

